<template>
     <v-dialog
      v-model="visible"
      max-width="600px"
      @click:outside="closeDialog()"
    > 
      <v-card role="alert">
        <v-card-title class="headline error--text text-center">Errore</v-card-title>

        <v-card-text>
          <div v-for="message in messages" :key="message">
            {{ message }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeDialog()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: "error-dialog",
  data() {
    return {
    };
  },
  methods: {
    closeDialog() {
      this.$store.state.errorDialogMessages = [];
      this.$store.state.errorDialog = false;
    },
  },
   computed: {
    messages() {
      return this.$store.state.errorDialogMessages;
    },
    visible() {
      return this.$store.state.errorDialog;
    }
  },
  created() {}
};
</script>

<style scoped>
  .v-card__text div {
    font-size: 18px;
    font-weight: bold;
  }
</style>